import { graphql } from 'src/graphql';

export const TaskBlock = graphql(`
  fragment TaskBlock on TaskBlock @_unmask {
    __typename
    _id
    type
    title
    instructions
    image
    image_path
    recording_options {
      screen
      camera
      microphone
    }
    conditional_logic {
      next_block {
        ... on ConditionalLogicNextBlockTask {
          action
          _id
        }
        ... on ConditionalLogicNextBlockContinue {
          action
        }
        ... on ConditionalLogicNextBlockEnd {
          action
        }
      }
      figma_prototype {
        is_completed
      }
      multiple_choice_question {
        _option_ids
        is_other_selected
        type
      }
      opinion_scale {
        min
        max
      }
      variant_comparison {
        _variant_id
      }
      stack_rank {
        item_condition_type
        _item_ids
        rank_positions
      }
      tree_test {
        outcome
      }
    }
    show_primer
    ... on TaskBlockLiveWebsiteTest {
      _follow_up_ids
    }
    ... on TaskBlockVariantComparison {
      variant_comparison {
        options {
          ... on VariantComparisonOptionsExclusive {
            distribution_method
            exclusive_method
          }
          ... on VariantComparisonOptionsAlternating {
            distribution_method
          }
        }
        variants {
          _id
          title
          _child_ids
        }
      }
    }
  }
`);

export const TaskBlockFigmaPrototype = graphql(`
  fragment TaskBlockFigmaPrototype on TaskBlockFigmaPrototype @_unmask {
    figma_prototype {
      file_id
      goal_screen_id
      start_screen_id
      link_access
      prototype_password
      task_type
    }
  }
`);

export const TaskBlockLiveWebsiteTest = graphql(`
  fragment TaskBlockLiveWebsiteTest on TaskBlockLiveWebsiteTest @_unmask {
    live_website_test {
      url
    }
  }
`);

export const TaskBlockMultipleChoiceQuestion = graphql(`
  fragment TaskBlockMultipleChoiceQuestion on TaskBlockMultipleChoiceQuestion @_unmask {
    multiple_choice_question {
      options {
        _id
        value
      }
      has_other_option
      is_multiple_select
      is_randomised_order
      min_selections
      max_selections
    }
  }
`);

export const TaskBlockOpenAnswer = graphql(`
  fragment TaskBlockOpenAnswer on TaskBlockOpenAnswer @_unmask {
    open_answer {
      max_length
      response_type
    }
  }
`);

export const TaskBlockOpinionScale = graphql(`
  fragment TaskBlockOpinionScale on TaskBlockOpinionScale @_unmask {
    opinion_scale {
      is_zero_start
      label_low
      label_mid
      label_high
      scale_max
      scale_type
    }
  }
`);

export const TaskBlockCardSort = graphql(`
  fragment TaskBlockCardSort on TaskBlockCardSort @_unmask {
    card_sort {
      sort_type
      cards {
        _id
        title
        description
      }
      card_options {
        has_description
        has_image
        is_required_all
        is_required_rank
        is_randomised_order
      }
      categories {
        _id
        title
        description
        card_limit
      }
      category_options {
        has_description
        has_card_limit
        is_randomised_order
      }
    }
  }
`);

export const TaskBlockTreeTest = graphql(`
  fragment TaskBlockTreeTest on TaskBlockTreeTest @_unmask {
    tree_test {
      nodes {
        _id
        title
        parent_id
        is_goal
      }
    }
  }
`);

export const TaskBlockLiveMobileTest = graphql(`
  fragment TaskBlockLiveMobileTest on TaskBlockLiveMobileTest @_unmask {
    live_mobile_test {
      type
      url
    }
  }
`);

export const TaskBlockMatrix = graphql(`
  fragment TaskBlockMatrix on TaskBlockMatrix @_unmask {
    matrix {
      statements {
        _id
        label
      }
      scale_size
      scale_preset
      custom_scale_labels
      has_na_option
      is_randomised_order
    }
  }
`);

export const TaskBlockSystemUsabilityScale = graphql(`
  fragment TaskBlockSystemUsabilityScale on TaskBlockSystemUsabilityScale @_unmask {
    system_usability_scale {
      statements {
        _id
        label
      }
      subject_label
    }
  }
`);

export const TaskBlockVariantComparison = graphql(`
  fragment TaskBlockVariantComparison on TaskBlockVariantComparison @_unmask {
    variant_comparison {
      options {
        ... on VariantComparisonOptionsExclusive {
          distribution_method
          exclusive_method
        }
        ... on VariantComparisonOptionsAlternating {
          distribution_method
        }
      }
      variants {
        _id
        title
        _child_ids
      }
    }
  }
`);

export const TaskBlockStackRank = graphql(`
  fragment TaskBlockStackRank on TaskBlockStackRank @_unmask {
    stack_rank {
      is_randomised_order
      items {
        _id
        title
      }
    }
  }
`);

export const TaskBlockFields = graphql(
  `
    fragment TaskBlockFields on TaskBlock @_unmask {
      ...TaskBlock
      ...TaskBlockCardSort
      ...TaskBlockTreeTest
      ...TaskBlockFigmaPrototype
      ...TaskBlockLiveWebsiteTest
      ...TaskBlockMultipleChoiceQuestion
      ...TaskBlockOpenAnswer
      ...TaskBlockOpinionScale
      ...TaskBlockStackRank
      ...TaskBlockMatrix
      ...TaskBlockSystemUsabilityScale
      ...TaskBlockLiveMobileTest
      ...TaskBlockVariantComparison
    }
  `,
  [
    TaskBlock,
    TaskBlockCardSort,
    TaskBlockTreeTest,
    TaskBlockFigmaPrototype,
    TaskBlockLiveWebsiteTest,
    TaskBlockMultipleChoiceQuestion,
    TaskBlockOpenAnswer,
    TaskBlockOpinionScale,
    TaskBlockStackRank,
    TaskBlockMatrix,
    TaskBlockSystemUsabilityScale,
    TaskBlockLiveMobileTest,
    TaskBlockVariantComparison,
  ],
);
